import { withInstall } from '@vuemap/vue-amap-util'
import GLCustom from './GLCustom.vue'

export const ElAmapLayerGlCustom = withInstall(GLCustom)
export default ElAmapLayerGlCustom
